import S3Adapter from "@/adapters/s3.adapter";

/**
 * File Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    this.adapter = new S3Adapter();
  }

  /**
   * Storage のファイルにアクセスできるか（存在するか）確認する
   * @param   {[type]}  key  [S3 Object key]
   * @return  {[type]}       [return description]
   */
  async verifyFileOnStorage (key) {
    try {
      const url = await this.adapter.get(key);

      await fetch(url);

      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  }

  /**
   * [put description]
   * @param   {[type]}  fileName  [fileName description]
   * @param   {[type]}  file      [file description]
   * @param   {[type]}  option    [option description]
   * @return  {[type]}            [return description]
   */
  async put (fileName, file, option = {}) {
    try {
      const result = await this.adapter.put(fileName, file, option);

      // 利用している Storage のバージョンでは存在しないバケット指定などによる実行ではエラーの検知がされないようなので
      // 出力された Storage の key から実際にファイルへのアクセスが行えるかでどうかでファイルがアップロードされているか確認する
      // ※ データの整合性チェック的なもの（UI に起因した処理でない ＋ DB に対する確認）としてここで処理する
      await this.verifyFileOnStorage(result.key);

      return Promise.resolve(result);
    } catch (err) {
      console.log("ERROR@file.service.put", err);
      console.log("fileName: %s", fileName);

      return Promise.reject(err);
    }
  }

  /**
   * [remove description]
   * @param   {[type]}  fileName  [fileName description]
   * @param   {[type]}  option    [option description]
   * @return  {[type]}            [return description]
   */
  async remove (fileName, option = {}) {
    try {
      const result = await this.adapter.remove(fileName, option);

      return Promise.resolve(result);
    } catch (err) {
      console.log("ERROR@file.service.remove", err);
      console.log("fileName: %s", fileName);

      return Promise.reject(err);
    }
  }

  /**
   * [filepath description]
   * @param   {[type]}  key  [S3 Object key]
   * @return  {[type]}       [return description]
   */
  get (key) {
    return this.adapter.get(key);
  }
}
